import { Link } from 'react-router';

export function Forbidden() {
  return (
    <div className="forbidden-screen">
      <div className="empty">
        <h2>Forbidden</h2>
        <p>You don't have access to this page.</p>
        <p>
          <Link to="/events">Back to events</Link>
        </p>
      </div>
    </div>
  );
}
